import { request } from '@/shared/api/request'

export const getSickData = ({params, payload: {type: type}}) => request({ url: `contract/universalMethods/${type}/sickLeaves`, method: 'GET', params: params })